// Ported from twifi-theme-html/src/scripts/helpers/faq.js
function closeFaqItem(trigger) {
    const item = trigger.closest('.faq-item');
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));

    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    item.classList.remove('faq-item--open');
}

function toggleFaqItem(trigger) {
    const item = trigger.closest('.faq-item');
    const list = trigger.closest('.faq__list');
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';

    list.querySelectorAll('.faq-item__trigger').forEach((otherTrigger) => {
        if (otherTrigger !== trigger) closeFaqItem(otherTrigger);
    });

    trigger.setAttribute('aria-expanded', String(!isOpen));
    panel.setAttribute('aria-hidden', String(isOpen));
    item.classList.toggle('faq-item--open', !isOpen);
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.faq-item__trigger').forEach((trigger) => {
        trigger.addEventListener('click', () => toggleFaqItem(trigger));
    });
});
